import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './activity-comments.reducer';

export const ActivityCommentsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const activityCommentsEntity = useAppSelector(state => state.activityComments.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="activityCommentsDetailsHeading">
          <Translate contentKey="reachamyApp.activityComments.detail.title">ActivityComments</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{activityCommentsEntity.id}</dd>
          <dt>
            <span id="userID">
              <Translate contentKey="reachamyApp.activityComments.userID">User ID</Translate>
            </span>
          </dt>
          <dd>{activityCommentsEntity.userID}</dd>
          <dt>
            <span id="replyToMessage">
              <Translate contentKey="reachamyApp.activityComments.replyToMessage">Reply To Message</Translate>
            </span>
          </dt>
          <dd>{activityCommentsEntity.replyToMessage}</dd>
          <dt>
            <span id="imageUrl">
              <Translate contentKey="reachamyApp.activityComments.imageUrl">Image Url</Translate>
            </span>
          </dt>
          <dd>{activityCommentsEntity.imageUrl}</dd>
          <dt>
            <span id="createdAt">
              <Translate contentKey="reachamyApp.activityComments.createdAt">Created At</Translate>
            </span>
          </dt>
          <dd>
            {activityCommentsEntity.createdAt ? (
              <TextFormat value={activityCommentsEntity.createdAt} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="updatedAt">
              <Translate contentKey="reachamyApp.activityComments.updatedAt">Updated At</Translate>
            </span>
          </dt>
          <dd>
            {activityCommentsEntity.updatedAt ? (
              <TextFormat value={activityCommentsEntity.updatedAt} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
        </dl>
        <Button tag={Link} to="/activity-comments" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/activity-comments/${activityCommentsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ActivityCommentsDetail;
